import {
  GET_PREDICTED_SCORE_REQ,
  GET_PREDICTED_SCORE_SUCCESS,
  GET_TARGET_SCORE_FAILED,
  GET_TARGET_SCORE_REQ,
  GET_TARGET_SCORE_SUCCESS,
} from "../Constant/ScoreContacts";
import api from "../Core/api";

export const PredictedScoreData = () => async (dispatch) => {
  try {
    dispatch({ type: GET_PREDICTED_SCORE_REQ });
    const { data } = await api.get("/student/score/predicted");
    dispatch({ type: GET_PREDICTED_SCORE_SUCCESS, payload: data?.Result });
  } catch (error) {
    dispatch({
      type: GET_PREDICTED_SCORE_SUCCESS,
      payload:
        error.response && error.response.data.Result
          ? error.response.data.Result
          : error.message,
    });
  }
};

export const TargetScoreData = () => async (dispatch) => {
  try {
    dispatch({ type: GET_TARGET_SCORE_REQ });
    const { data } = await api.get("/student/score/target");
    dispatch({ type: GET_TARGET_SCORE_SUCCESS, payload: data?.Result });
  } catch (error) {
    dispatch({
      type: GET_TARGET_SCORE_FAILED,
      payload:
        error.response && error.response.data.Result
          ? error.response.data.Result
          : error.message,
    });
  }
};
